// src/lib/tracking/ab-tests.ts
// ════════════════════════════════════════════════════════════════════════════
// SINGLE SOURCE OF TRUTH FOR ALL AB TESTS
// ════════════════════════════════════════════════════════════════════════════

/**
 * Test definition type
 */
export interface Test<V extends string = string> {
  readonly id: string;
  readonly variants: readonly V[];
  readonly weights?: readonly number[];
  readonly matomoDimension?: number;
}

/**
 * Helper to define a test with proper typing
 */
export function defineTest<V extends string>(config: Test<V>): Test<V> {
  return config;
}

// ════════════════════════════════════════════════════════════════════════════
// TEST DEFINITIONS
// ════════════════════════════════════════════════════════════════════════════

/**
 * CV Upload Flow Test
 * 
 * Variants:
 * - a: Direct file picker (button click → file input)
 * - b: Dedicated page (button click → /drop-cv)
 * - c: Modal dialog (button click → dialog with file upload)
 * 
 * Funnel: button-clicked → file-selected → upload-started → upload-completed 
 *         → parse-completed → form-viewed → form-submitted → record-saved
 */
export const cvUploadTest = defineTest({
  id: 'cv-upload',
  variants: ['a', 'b', 'c'],
  weights: [1, 1, 1], // Equal distribution
  matomoDimension: 2,
});

// ════════════════════════════════════════════════════════════════════════════
// EXPORTS FOR DEBUG PANEL
// ════════════════════════════════════════════════════════════════════════════

/** All active tests (for debug panel) */
export const ALL_TESTS = [cvUploadTest] as const;